import { call } from "../helpers/axiosInterceptor";

const getCoachesList = async () => {
  const data = await call.get("coach", {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("refToken"),
    },
  });

  return data.data;
};

const createCoach = async (payload) => {
  const { data } = await call.post("coach", { ...payload }, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("refToken"),
    },
  });
  return data;
};

const getCoachbatch = async (id) => {
  const { data } = await call.get(`batch/coach-batch/${id}`, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("refToken"),
    },
  });
  return data;
};

const getCoachbatches = async (coachId) => {
  try {
    const { data } = await call.get(`batch/search/coach-batch/${coachId}`, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("refToken"),
      },
    });
    return data;
  } catch (error) {
    console.error("❌ Error fetching coach batches:", error);
    return { message: 'Failed to fetch batches', data: [] };
  }
};


const updateCoach = async (payload) => {
  if (!payload._id) throw new Error("Coach ID is required");

  const { data } = await call.put(`coach/${payload._id}`, payload, {  // ✅ Use PUT instead
    headers: {
      Authorization: "Bearer " + localStorage.getItem("refToken"),
    },
  });

  return data;
};

// New function to get coach details
const getCoachDetails = async (id) => {
  const { data } = await call.get(`coach/${id}`, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("refToken"),
    },
  });
  return data;
};

const deleteCoach = async (coachId: string) => {
  try {
    

    const response = await call.delete(`/coach/${coachId}`, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("refToken"),
      },
    });
  } catch (e: any) {
    console.error("Error deleting Coach:", e.response?.data?.message || e.message);
  }
};

export const changeCoachPassword = async (
  token: string,
  currentPassword: string,
  newPassword: string,
  confirmPassword: string
) => {
  try {
    const response = await call.post(
      "coach/change-password",
      { currentPassword, newPassword, confirmPassword },
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("refToken"),
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error in changePassword:", error);
    throw error;
  }
};

export {
  createCoach,
  getCoachesList,
  getCoachbatch,
  updateCoach,
  getCoachbatches,
  getCoachDetails, // Exporting the new function
  deleteCoach,
};
